import { Injectable } from '@angular/core';

import { EFeatureFlag } from '@app/feature-toggle-list';
import { FeatureToggleService } from '@app/shared/services/feature-toggle.service';

import {
  ESalesOrderSource,
  ESalesOrderStatus,
  ISalesOrder,
  IOrderShippabilityErrors,
} from '../../../order/interfaces/order.interface';

@Injectable({
  providedIn: 'root',
})
export class OrderUtilService {
  constructor(private featureToggleService :FeatureToggleService) {}

  checkOrderShippabilityErrors(order :ISalesOrder) :IOrderShippabilityErrors {
    // TODO: Should be moved to backend integrations for single source of this settings / truth
    const clientInvoiceSourceTypes :any[] = [
      ESalesOrderSource.LUMINOUS,
      ESalesOrderSource.EDI,
      ESalesOrderSource.SALES_ORDER,
      ESalesOrderSource.NUORDER,
    ];
    const isItemsFullyPushedToShipstation = order?.orderItems?.every(
      (item) => item.status !== ESalesOrderStatus.PENDING,
    );
    const orderShippabilityObject = {
      missingBillingDetails: !order.billTo,
      missingShippingDetails: !order.shipTo,
      isCancelledOrder: order.orderStatus === ESalesOrderStatus.CANCELLED,
      hasShipstationOrderId: order?.shipstationOrderId > 0,
      isShipstation: order.source === ESalesOrderSource.SHIPSTATION,
      isNotPosted: !order.isPosted,
      isNotShippable: false,
    };
    if (this.partialFulfillmentEnabled) {
      orderShippabilityObject.hasShipstationOrderId =
        orderShippabilityObject.hasShipstationOrderId &&
        isItemsFullyPushedToShipstation;
    }

    const isNotShippable = Object.values(orderShippabilityObject).some(
      (state :boolean) => state,
    );

    return {
      ...orderShippabilityObject,
      isNotShippable: isNotShippable,
    };
  }

  get partialFulfillmentEnabled() :boolean {
    return this.featureToggleService.featureEnabled(
      'red_DV-2840_partial_fulfillment',
    );
  }
}
